import { IMenuItemScope } from "./menu";

export function QpMenuItemDirective($timeout: angular.ITimeoutService, $injector: angular.auto.IInjectorService): angular.IDirective {
    return {
        restrict: "AE",
        scope: {
            // 菜单项唯一标识
            qpMenuItem: "<",
            itemId: "<"
        },
        require: ["^?qpMenu", "^?qpMenuChild", "^?qpMenuItem"],
        controllerAs: "ctrl",
        controller: [function () {


        }],
        link: (scope: any, element: JQLite, attr, ctrls: Array<angular.IController>) => {
            let itemId = scope.qpMenuItem || scope.itemId;
            // if (angular.isUndefined(itemId)) {
            //     itemId = 
            // }

            const menuCtrl = ctrls[0];
            const childMenuCtrl = ctrls[1];
            const selfCtrl = ctrls[2];

            selfCtrl.itemId = itemId;

            let parentCtrl = childMenuCtrl ? childMenuCtrl : menuCtrl;

            // 添加菜单项
            parentCtrl.addItem(selfCtrl);

            // 监听鼠标移入事件
            element.on("mouseover", () => {
                parentCtrl.childMouseover(selfCtrl.itemId);
            })
            // 监听鼠标移出事件
            element.on("mouseout", () => {
                parentCtrl.childMouseout(selfCtrl.itemId);
            })

        }
    }
}

QpMenuItemDirective.$inject = ["$timeout", "$injector"];